import { Fragment, useLayoutEffect } from 'react';
import type { Chat } from '@trinity/chat';
import { useChatPermissions } from './hooks/useChatPermissions';
import { useScrollToBottomOfMessages } from './hooks/useScrollMessageList';
import { QueryItem } from './Item.Query';

type Props = {
  queries: Chat.Query[];
};

export const MessageList = ({ queries }: Props) => {
  const scrollToBottom = useScrollToBottomOfMessages();
  const chatPermissions = useChatPermissions();

  useLayoutEffect(() => {
    scrollToBottom();
  }, [scrollToBottom]);

  const view = {
    regenerate: chatPermissions.canModify,
  };

  return (
    <Fragment>
      {queries.map((query, i) => (
        <QueryItem
          key={i}
          canRegenerate={view.regenerate && i === queries.length - 1}
          query={query} />
      ))}
    </Fragment>
  );
};